var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11.5,
    stroke: "#828282",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75C15.2072 8.75 15.4059 8.83231 15.5524 8.97882C15.6989 9.12534 15.7812 9.32405 15.7812 9.53125V14.2188H20.4688C20.676 14.2188 20.8747 14.3011 21.0212 14.4476C21.1677 14.5941 21.25 14.7928 21.25 15C21.25 15.2072 21.1677 15.4059 21.0212 15.5524C20.8747 15.6989 20.676 15.7812 20.4688 15.7812H15.7812V20.4688C15.7812 20.676 15.6989 20.8747 15.5524 21.0212C15.4059 21.1677 15.2072 21.25 15 21.25C14.7928 21.25 14.5941 21.1677 14.4476 21.0212C14.3011 20.8747 14.2188 20.676 14.2188 20.4688V15.7812H9.53125C9.32405 15.7812 9.12534 15.6989 8.97882 15.5524C8.83231 15.4059 8.75 15.2072 8.75 15C8.75 14.7928 8.83231 14.5941 8.97882 14.4476C9.12534 14.3011 9.32405 14.2188 9.53125 14.2188H14.2188V9.53125C14.2188 9.32405 14.3011 9.12534 14.4476 8.97882C14.5941 8.83231 14.7928 8.75 15 8.75Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkPlus);
export default __webpack_public_path__ + "static/media/network-plus.bc8a1b66.svg";
export { ForwardRef as ReactComponent };